//dependencies
import { formatISO } from "date-fns";

import { ReviewsOfMeFilters } from "./components/ReviewsOfMeFilterPanel";

export const getFiltersForSearchService = (filters: ReviewsOfMeFilters, userId: string, searchTerm?: string) => {
	const baseFilters = {
		subject_in: userId,
		name_re: searchTerm,
		user_being_viewed: userId,
	};

	if (filters?.status && filters?.status !== "any") {
		if (filters.status === "complete") {
			baseFilters["completed_eq"] = true;
		} else if (filters.status === "scheduled") {
			baseFilters["completed_ne"] = true;
			baseFilters["start_date_gt"] = formatISO(new Date());
		} else if (filters.status === "active") {
			baseFilters["completed_ne"] = true;
			baseFilters["start_date_lt"] = formatISO(new Date());
		}
	}

	if (filters?.easyAddStatus) {
		if (filters.easyAddStatus === "easyAddEnabled") {
			baseFilters["360_count_gt"] = 0;
		} else if (filters.easyAddStatus === "awaitingApproval") {
			baseFilters["awaiting_approval_count_gt"] = 0;
		}
	}

	return baseFilters;
};
